export default "__VITE_ASSET__CHz8tsWd__"